import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react';
import {config} from '../config';
import {getSessionToken} from '../utils/authSession';

const jsonPost = (url, body) => ({url, method: 'POST', body});
// Add endpoints may reply with an empty or non-JSON body; only the status matters.
const addPost = (url, body) => ({...jsonPost(url, body), responseHandler: (res) => res.text()});

export const catalogApi = createApi({
	reducerPath: 'catalogApi',
	baseQuery: fetchBaseQuery({
		baseUrl: `${config.API_MSWSSTOREMANAGER_BASE_URL}/v2`,
		prepareHeaders: (headers) => {
			headers.set('X-Session-Token', getSessionToken());
			return headers;
		},
	}),
	tagTypes: ['Department', 'Category', 'SubCategory'],
	endpoints: (builder) => ({
		getDepartments: builder.query({
			query: (vendorId) => jsonPost('/getDepartmentsByVendor', {vendorId}),
			transformResponse: (res) => res || [],
			providesTags: ['Department'],
		}),
		addDepartment: builder.mutation({
			query: ({departmentName, vendorId}) =>
				addPost('/addDepartment', {departmentName: `${departmentName}`, vendorId}),
			invalidatesTags: ['Department'],
		}),

		getCategories: builder.query({
			query: ({vendorId, parentId}) =>
				jsonPost('/getCategoriesByVendor', {vendorId, parentCatagoryId: parentId}),
			transformResponse: (res) => res || [],
			providesTags: ['Category'],
		}),
		addCategory: builder.mutation({
			query: ({categoryName, deptId, vendorId}) =>
				addPost('/addCategory', {
					department: {id: `${deptId}`},
					categoryName: `${categoryName}`,
					vendorId: `${vendorId}`,
				}),
			invalidatesTags: ['Category'],
		}),

		getSubCategories: builder.query({
			query: ({vendorId, parentId}) =>
				jsonPost('/getSubCategoriesByVendor', {vendorId, parentCatagoryId: parentId}),
			transformResponse: (res) => res || [],
			providesTags: ['SubCategory'],
		}),
		addSubCategory: builder.mutation({
			query: ({subCategoryName, catId, vendorId}) =>
				addPost('/addSubCategory', {
					category: {id: `${catId}`},
					subCategoryName: `${subCategoryName}`,
					vendorId: `${vendorId}`,
				}),
			invalidatesTags: ['SubCategory'],
		}),

		deleteCatalogEntity: builder.mutation({
			query: ({entityType, vendorId, id}) =>
				jsonPost('/catalog/delete', {entityType, vendorId, id}),
			invalidatesTags: (result, error, {entityType}) => {
				if (!result?.canDelete) return [];
				return [{department: 'Department', category: 'Category', subcategory: 'SubCategory'}[entityType]];
			},
		}),
	}),
});

export const {
	useGetDepartmentsQuery,
	useAddDepartmentMutation,
	useGetCategoriesQuery,
	useAddCategoryMutation,
	useGetSubCategoriesQuery,
	useAddSubCategoryMutation,
	useDeleteCatalogEntityMutation,
} = catalogApi;
